import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap';
import Select from 'react-select';

import sessionTypes from 'data/ai_session_types';

export default function Filters({
  keyword, setKeyword, sessionType, setSessionType, enterprise, setEnterprise,
}) {
  return (
    <div className="invite_search">
      <Row>
        <Col md={3}>
          <input
            type="text"
            placeholder="Member or Avatar"
            className="form-control"
            value={keyword}
            onChange={(e) => setKeyword(e.target.value)}
          />
        </Col>
        <Col md={3}>
          <Select
            value={sessionType}
            onChange={(item) => setSessionType(item)}
            placeholder="Session Type"
            options={sessionTypes}
            isClearable
          />
        </Col>
        <Col md={3}>
          <input
            type="text"
            placeholder="Enterprise"
            className="form-control"
            value={enterprise}
            onChange={(e) => setEnterprise(e.target.value)}
          />
        </Col>
      </Row>
    </div>
  );
}

Filters.propTypes = {
  keyword: PropTypes.string.isRequired,
  setKeyword: PropTypes.func.isRequired,
  sessionType: PropTypes.object,
  setSessionType: PropTypes.func.isRequired,
  enterprise: PropTypes.string.isRequired,
  setEnterprise: PropTypes.func.isRequired,
};

Filters.defaultProps = {
  sessionType: null,
};
